import * as React from 'react';
import * as i18n from 'i18next';
import { reduxForm, InjectedFormProps, Field, submit, change, getFormSyncErrors } from 'redux-form';
const { connect } = require('react-redux');
const { asyncConnect } = require('redux-connect');
import { translate } from 'react-i18next';
import { IStore } from 'redux/IStore';
import {
	getArticle,
	submitCreateArticle,
	submitUpdateArticle,
	clearFormData,
	setCoverImagesTab,
	clearManageArticleFormError,
	setManageArticleValidationFailure,
	setArticleStatus,
	cropAndSaveCoverImage,
	cropAndSaveSliderImage,
	setOriginalArticleItems,
} from 'modules/magazine/article/managearticle';
import { showModal, closeModal } from 'modules/modal';
import * as c from 'models/constants';
import { IManageArticle, IManageArticleAction } from 'models/magazine/article/managearticle';
import { IArticle } from 'models/magazine/article/article';
import { IImageData, ICropImageData } from 'models/common';
import { IUserListItem } from 'models/user/userlistitem';
import { IUserPreferences } from 'models/user/userpreferences';
import { IModalAction } from 'models/modal';
import { IArticleTagDomainValue } from 'models/magazine/article/articletagdomainvalue';
import { ArticleStatus } from 'models/enums/statuses';
import { IArticleCardAction } from 'models/magazine/article/articlecard';
import { ILanguage } from 'models/common';
import {
	CKEditor,
	PortalSelectMenu,
	PortalInputField,
	PortalTextareaField,
	ImageUpload,
} from 'components/FormControls';
import { IButton, ICommand } from 'components/FormControls/CKEditor';
import { Button, WhiteButton } from 'components';
import { required, maxLength, alphabetAndMinusCharacter, scrollErrorIntoView } from 'helpers/validationattributes';
import { nullCheck, arraysAreSame, generateSlug } from 'helpers/common';
import { SidebarBlock, PortalPageSection, ButtonsSection, RightColumnPortalPage } from 'components/PortalStructure';
import { browserHistory, InjectedRouter } from 'react-router';
import { AuthConsumer } from 'containers';
import { actions as notifActions } from 'redux-notifications';
import { IProductListItemCard } from 'models/product/productlistitem';
import { IArticleProductItem } from 'models/magazine/article/articleproductitem';
import renderIcon from 'helpers/renderIcon';
import { IFetchDefault } from 'redux/modules/fetch';
import { preventRouterLeave } from 'helpers/hooks';
const { notifSend } = notifActions;

require('components/Tabs/style.css');

interface IProps extends InjectedFormProps {
	userPreferences?: IUserPreferences;
	manageArticle: IManageArticle;
	initialValues: IManageArticle;
	currentFormValues: IArticle;
	languageDomainValues: ILanguage[];
	dispatch?: any;
	location: any;
	router: InjectedRouter;
	route: any;
	baseAPI?: string;
	fetchDefault?: IFetchDefault;

	/* form props */
	pristine: boolean;
	dirty: boolean;
	submitting: boolean;
	submitFailed: boolean;
	handleSubmit: any;
	formErrors?: any;
	submit: (formName: string) => void;
	change: (field: string, value: any) => void;
	changeFormField: (formName: string, field: string, value: any) => void;
	reset: () => void;

	/* functions props */
	getArticle: (id: string) => IManageArticleAction;
	submitCreateArticle: (article: IArticle, approve?: boolean) => IManageArticleAction;
	submitUpdateArticle: (article: IArticle, approve?: boolean) => IManageArticleAction;
	setArticleStatus: (id: string, status: ArticleStatus) => IArticleCardAction;
	clearFormData: () => IManageArticleAction;
	setManageArticleValidationFailure: (error: any) => IManageArticleAction;
	clearManageArticleFormError: () => IManageArticleAction;
	setCoverImagesTab: (tab: string) => IArticleCardAction;
	t?: (key: string, object?: any) => string;
	showModal: (modalType: string, modalProps: any) => IModalAction;
	closeModal: () => IModalAction;
	cropAndSaveCoverImage: (image: ICropImageData) => void;
	cropAndSaveSliderImage: (image: ICropImageData, slideIndex: number, fieldName: string, formName: string) => void;
	setOriginalArticleItems: (items: IArticleProductItem[]) => IManageArticleAction;
	notifSend: (data: any) => void;
}

const maxLength255 = maxLength(255);
const maxLength500 = maxLength(500);

@asyncConnect([
	{
		promise: ({ store: { dispatch }, params }) => dispatch(getArticle(params.id)),
	},
])
@preventRouterLeave()
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ManageArticleForm extends React.Component<IProps, any> {
	private advancedSettingsPopUp: HTMLElement = null;
	private galleryPopUp: HTMLElement = null;
	private addButtons: IButton[] = [];
	private addCommands: ICommand[] = [];
	private coverImagesPristine: boolean = true;
	private dropzoneRef: any;
	constructor(props) {
		super(props);

		this.onSubmit = this.onSubmit.bind(this);
		this.approveArticle = this.approveArticle.bind(this);
		this.searchProfile = this.searchProfile.bind(this);
		this.selectProfile = this.selectProfile.bind(this);
		this.mainImageUploadedCallback = this.mainImageUploadedCallback.bind(this);
		this.imageUploadFailed = this.imageUploadFailed.bind(this);
		this.imageUploadSuccess = this.imageUploadSuccess.bind(this);
		this.openAdvancedSettings = this.openAdvancedSettings.bind(this);
		this.closeAdvancedSettings = this.closeAdvancedSettings.bind(this);
		this.openGaleryPopUp = this.openGaleryPopUp.bind(this);
		this.deleteMainImage = this.deleteMainImage.bind(this);
		this.deleteSlideImage = this.deleteSlideImage.bind(this);
		this.clearMainImageData = this.clearMainImageData.bind(this);
		this.onLanguageChange = this.onLanguageChange.bind(this);
		this.editCoverImage = this.editCoverImage.bind(this);
		this.mapErrorKeyToMessage = this.mapErrorKeyToMessage.bind(this);
		this.removeArticleItem = this.removeArticleItem.bind(this);
		this.selectItemObject = this.selectItemObject.bind(this);
		this.onCancelItemsSelector = this.onCancelItemsSelector.bind(this);
		this.onItemsSelectorSave = this.onItemsSelectorSave.bind(this);
		this.updateItemsData = this.updateItemsData.bind(this);

		const openGalleryButton: IButton = {
			name: 'OpenGallery',
			settings: {
				label: i18n.t('Magazine_Article_ManageArticle_CKEditorButton_OpenGallery'),
				command: 'openGallery',
				toolbar: 'insert',
			},
		};
		const itemsSelectorButton: IButton = {
			name: 'OpenItemsSelector',
			settings: {
				label: i18n.t('Magazine_Article_ManageArticle_CKEditorButton_OpenItemsSelector'),
				command: 'openItemsSelector',
				toolbar: 'insert',
			},
		};
		this.addButtons.push(openGalleryButton);
		this.addButtons.push(itemsSelectorButton);

		const openGalleryCommand: ICommand = {
			name: 'openGallery',
			exec: () => {
				this.openGaleryPopUp();
				return true;
			},
		};

		const openItemsSelectorCommand: ICommand = {
			name: 'openItemsSelector',
			exec: () => {
				this.props.showModal('ArticleFeaturedProductsSelectorModal', {
					onRemoveItem: this.removeArticleItem,
					onSelectItemObject: this.selectItemObject,
					closeModal: this.props.closeModal,
					onCancelItemsSelector: this.onCancelItemsSelector,
					onItemsSelectorSave: this.onItemsSelectorSave,
				});
				return true;
			},
		};

		this.addCommands.push(openGalleryCommand);
		this.addCommands.push(openItemsSelectorCommand);

		this.dropzoneRef = React.createRef<HTMLDivElement>();
	}

	public componentDidMount() {
		if (!this.props.manageArticle.isEditMode) {
			this.props.clearFormData();
		}
	}

	public componentDidUpdate(prevProps: IProps) {
		if (prevProps.manageArticle && prevProps.manageArticle.isEditMode && !this.props.manageArticle.isEditMode) {
			this.props.clearFormData();
		}
		// check if cover images have changed
		if (
			prevProps.manageArticle &&
			prevProps.manageArticle.article &&
			prevProps.manageArticle.article.coverImages &&
			this.props.currentFormValues &&
			this.props.currentFormValues.coverImages &&
			(prevProps.manageArticle.article.coverImages.length !== this.props.currentFormValues.coverImages.length ||
				(prevProps.manageArticle.article.coverImages.length === this.props.currentFormValues.coverImages.length &&
					!arraysAreSame(prevProps.manageArticle.article.coverImages, this.props.currentFormValues.coverImages)))
		) {
			// this.coverImagesPristine = false;
		}
	}

	public componentWillUnmount() {
		this.props.setCoverImagesTab('slide_0');
	}

	public onSubmit(form: IArticle, isApproval: boolean) {
		if (form.tags) {
			const tags = form.tags.join(' ');
			form.tags = tags.trim();
		}

		let firstCoverSliderImage: IImageData = null;

		if (
			this.props.currentFormValues &&
			this.props.currentFormValues.coverImages &&
			this.props.currentFormValues.coverImages.length > 1
		) {
			firstCoverSliderImage = this.props.currentFormValues.coverImages[0];
		}

		const coverImages: IImageData[] = [];

		if (firstCoverSliderImage) {
			form.picture = firstCoverSliderImage.href;
			form.pictureId = firstCoverSliderImage.id;
			form.pictureTitle = firstCoverSliderImage.description;
			form.pictureAuthor = firstCoverSliderImage.author;

			// check if all cover images have all properties
			for (const cImage in this.props.currentFormValues.coverImages) {
				if (
					nullCheck(this.props.currentFormValues.coverImages[cImage].id) &&
					nullCheck(this.props.currentFormValues.coverImages[cImage].href)
				) {
					coverImages.push(this.props.currentFormValues.coverImages[cImage]);
				}
			}
		}

		// add main image to cover images
		if (nullCheck(form.picture) && nullCheck(form.pictureId) && coverImages.length === 0) {
			coverImages.push({
				href: form.picture,
				id: form.pictureId,
				description: form.pictureTitle,
				author: form.pictureAuthor,
			});
		}

		form.coverImages = coverImages;

		// check if all galery images have all properties
		const galleryImages: IImageData[] = [];
		for (const cImage in this.props.currentFormValues.galleryImages) {
			if (
				nullCheck(this.props.currentFormValues.galleryImages[cImage].id) &&
				nullCheck(this.props.currentFormValues.galleryImages[cImage].href) &&
				nullCheck(this.props.currentFormValues.galleryImages[cImage].description)
			) {
				galleryImages.push(this.props.currentFormValues.galleryImages[cImage]);
			}
		}
		form.galleryImages = galleryImages;

		if (this.props.manageArticle.isEditMode) {
			Promise.all([this.props.submitUpdateArticle(form, isApproval)])
				.then(() => {
					this.props.reset();
				})
				.then(() => {
					if (this.props.manageArticle.error) return;
					browserHistory.replace(`/profile/${this.props.userPreferences.id}`);
				})
				.catch(() => {
					this.props.notifSend({ message: this.props.t('Error_Generic'), kind: 'error', dismissAfter: 3000 });
				});
		} else {
			Promise.all([this.props.submitCreateArticle(form, isApproval)])
				.then(() => {
					if (
						this.props.manageArticle.article.id &&
						this.props.userPreferences.isAdministrator &&
						this.props.manageArticle.article.status === 1
					) {
						this.approveArticle();
					}
				})
				.then(() => {
					this.props.reset();
				})
				.then(() => {
					if (this.props.manageArticle.error) return;
					browserHistory.replace(`/profile/${this.props.userPreferences.id}`);
				})
				.catch(() => {
					this.props.notifSend({ message: this.props.t('Error_Generic'), kind: 'error', dismissAfter: 3000 });
				});
		}
	}

	private approveArticle() {
		this.props.setArticleStatus(this.props.manageArticle.article.id, ArticleStatus.Approved);
	}

	private selectProfile(data: IUserListItem) {
		this.props.closeModal();
		this.props.change('addedBy', data.name);
		this.props.change('userId', JSON.parse(data.entityId).id);
	}

	private searchProfile(e: any) {
		e.preventDefault();
		this.props.showModal('SearchProfiles', {
			selectProfile: this.selectProfile,
			closeModal: this.props.closeModal,
			showHeaderCloseButton: true,
		});
	}

	private imageUploadFailed(error: any) {
		this.props.setManageArticleValidationFailure(error);
		this.forceUpdate();
	}

	private imageUploadSuccess() {
		this.props.clearManageArticleFormError();
	}

	private mainImageUploadedCallback(id: string, href: string, additionalData: string[]) {
		const image: IImageData = {
			id,
			href,
		};

		if (additionalData.length > 0) {
			this.props.change(additionalData[0], image.href);
			this.props.change(additionalData[1], image.id);
		}

		this.forceUpdate();
	}

	private deleteMainImage() {
		this.props.change('picture', null);
		this.props.change('pictureId', null);
		this.props.change('pictureTitle', null);
		this.props.change('pictureAuthor', null);
		this.props.change('coverImages', []);
		this.forceUpdate();
	}

	private clearMainImageData() {
		this.props.change('picture', null);
		this.props.change('pictureId', null);
	}

	private deleteSlideImage(index) {
		this.props.currentFormValues.coverImages[index].id = null;
		this.props.currentFormValues.coverImages[index].href = null;
		if (index === 0) {
			this.clearMainImageData();
		}

		this.forceUpdate();
	}

	public handleAddCoverSliderCheckbox(checked: boolean) {
		const currentFormValues = this.props.currentFormValues;
		this.props.change('displayCoverSliderFields', checked);
		// delete cover images if cover slider is disabled
		if (!checked && currentFormValues && currentFormValues.coverImages && currentFormValues.coverImages.length > 1) {
			const firstItem = currentFormValues.coverImages[0];
			const coverImages: IImageData[] = [];
			coverImages.push(firstItem);
			this.props.change('coverImages', coverImages);
			// select tab if there is any cover image
		} else if (
			checked &&
			currentFormValues &&
			currentFormValues.coverImages &&
			currentFormValues.coverImages.length > 0
		) {
			this.props.setCoverImagesTab('slide_0');
			// add slide if there are no cover images and select it
		} else if (
			checked &&
			currentFormValues &&
			(!currentFormValues.coverImages || (currentFormValues.coverImages && currentFormValues.coverImages.length === 0))
		) {
			this.props.change('coverImages', [
				{
					id:
						this.props.currentFormValues.picture && this.props.currentFormValues.pictureId
							? this.props.currentFormValues.pictureId
							: null,
					href:
						this.props.currentFormValues.picture && this.props.currentFormValues.pictureId
							? this.props.currentFormValues.picture
							: null,
					description:
						this.props.currentFormValues.picture &&
						this.props.currentFormValues.pictureId &&
						this.props.currentFormValues.pictureTitle
							? this.props.currentFormValues.pictureTitle
							: null,
					author:
						this.props.currentFormValues.picture &&
						this.props.currentFormValues.pictureId &&
						this.props.currentFormValues.pictureAuthor
							? this.props.currentFormValues.pictureAuthor
							: null,
				},
			]);
			this.props.setCoverImagesTab('slide_0');
		}

		this.forceUpdate();
	}

	public openAdvancedSettings() {
		this.advancedSettingsPopUp.classList.add('setTable');
		setTimeout(() => {
			this.advancedSettingsPopUp.classList.add('active');
		}, 2);
	}

	public closeAdvancedSettings(e: any) {
		e.preventDefault();
		this.advancedSettingsPopUp.classList.remove('active');
		setTimeout(() => {
			this.advancedSettingsPopUp.classList.remove('setTable');
		}, 300);
	}

	public openGaleryPopUp() {
		this.galleryPopUp.classList.add('setTable');
		setTimeout(() => {
			this.galleryPopUp.classList.add('active');
		}, 2);
	}

	private mapErrorKeyToMessage(key: string, t: (key: string, object?: any) => string, index?: number) {
		if (index !== undefined && index !== null) {
			index = index + 1;
			switch (key) {
				case 'description':
					return t('Magazine_Article_ManageArticle_Label_CoverSlider_ImageDescriptionWithIndex', { index });
				case 'author':
					return t('Magazine_Article_ManageArticle_Label_CoverSlider_ImageAuthorWithIndex', { index });
				default:
					return key;
			}
		} else {
			switch (key) {
				case 'title':
					return t('Magazine_Article_ManageArticle_Label_Title');
				case 'code':
					return t('Magazine_Article_ManageArticle_Label_FriendlyUrl');
				case 'languageKey':
					return t('Magazine_Article_ManageArticle_Label_Language');
				case 'body':
					return t('Magazine_Article_ManageArticle_Label_Body');
				case 'tags':
					return t('Magazine_Article_ManageArticle_Label_Tags');
				case 'description':
					return t('Magazine_Article_ManageArticle_Label_CoverSlider_ImageDescription');
				case 'author':
					return t('Magazine_Article_ManageArticle_Label_CoverSlider_ImageAuthor');
				case 'pictureTitle':
					return t('Magazine_Article_ManageArticle_Label_CoverSlider_ImageDescription');
				case 'pictureAuthor':
					return t('Magazine_Article_ManageArticle_Label_CoverSlider_ImageAuthor');
				default:
					return key;
			}
		}
	}

	public onLanguageChange() {
		this.props.change('tags', '');
	}

	private editCoverImage() {
		this.props.showModal('CropImageModal', {
			closeModal: this.props.closeModal,
			saveImage: this.props.cropAndSaveCoverImage,
			modalTitle: this.props.t('Magazine_Article_ManageArticle_CropImageModalTitle'),
			cropOptions: {
				...c.DEFAULT_CROP_OPTIONS,
				aspectRatio: 2 / 3,
			},
			imageId: this.props.currentFormValues?.pictureId ? this.props.currentFormValues.pictureId : undefined,
			imageType: 'article',
		});
	}

	private removeArticleItem(index: number) {
		const itemsJArray = this.props.currentFormValues.itemsJArray;
		itemsJArray.splice(index, 1);
		let i;
		for (i = 0; i < itemsJArray.length; i++) {
			itemsJArray[i].order = i;
		}
		this.updateItemsData(itemsJArray);
	}

	private selectItemObject(item: IProductListItemCard) {
		if (this.props.manageArticle.article.itemsJArray.length < 20) {
			const itemsJArray = this.props.currentFormValues.itemsJArray;
			const itemToAdd: IArticleProductItem = {
				id: item.id,
				addedBy: item.addedBy,
				name: item.name,
				entityId: item.entityId,
				picture: item.picture,
				price: item.price,
				shopId: item.shopId,
				order: itemsJArray.length,
				shopCurrencyKey: item.shopCurrencyKey,
			};
			itemsJArray.push({
				...itemToAdd,
			});
			this.updateItemsData(itemsJArray);
		} else {
			this.props.notifSend({
				message: this.props.t('Magazine_Article_ManageArticle_NumberOfItems'),
				kind: 'warning',
				dismissAfter: 3000,
			});
		}
	}

	private onCancelItemsSelector() {
		this.props.closeModal();
		const originalArticleItems = this.props.manageArticle.originalArticleItems.map((x) => {
			return { ...x };
		});
		this.updateItemsData([...originalArticleItems]);
	}

	private onItemsSelectorSave() {
		this.props.closeModal();
		const items = this.props.currentFormValues.itemsJArray.map((x) => {
			return { ...x };
		});
		this.props.setOriginalArticleItems([...items]);
	}

	private updateItemsData(items: IArticleProductItem[]) {
		this.props.change('items', JSON.stringify(items));
		this.props.change('itemsJArray', items);
	}

	private handleTitleChange(e) {
		this.props.change('name', e.target.value);
		const generatedSlug = generateSlug(e.target.value);
		this.props.change('code', generatedSlug);
	}

	/** --------------RENDER ----------------------- */
	public render() {
		const { handleSubmit, t, currentFormValues, userPreferences, baseAPI } = this.props;
		const { articleTags, /*error, message,*/ userTokenForUpload } = this.props.manageArticle;

		let tags = [];
		if (articleTags.length > 0) {
			tags = articleTags
				.filter((x) => x.languageKey?.toString() === currentFormValues.languageKey?.toString())
				.map((tag: IArticleTagDomainValue) => {
					return {
						key: tag.value,
						value: tag.value,
					};
				});
		}

		const imagesPristine = this.props.pristine && this.coverImagesPristine;

		let saveAsDraftButton: JSX.Element = null;
		let approveButton: JSX.Element = null;
		if (currentFormValues && currentFormValues.status === ArticleStatus.Draft) {
			saveAsDraftButton = (
				<WhiteButton
					// usage="admin"
					onClick={handleSubmit((values) => {
						this.onSubmit(values, false);
					})}
					disabled={imagesPristine || this.props.submitting}
				>
					{t('BSPortal_Common_SaveAsDraft')}
				</WhiteButton>
			);
		}
		approveButton = (
			<Button
				onClick={handleSubmit((values) => {
					this.onSubmit(values, true);
				})}
				disabled={imagesPristine || this.props.submitting}
			>
				{t('BSPortal_Common_Save')}
			</Button>
		);

		const articleGalleryTitleValidators = [maxLength255];
		if (currentFormValues && currentFormValues.galleryImages && currentFormValues.galleryImages.length > 0) {
			articleGalleryTitleValidators.push(required);
		}

		const editableContentTextBlock = (
			<div>
				{/* <div className="ArticleErrorSummary"><ErrorSummary {...errorSummaryProps} /></div> */}
				<p className="p14 blockTitle">{t('Magazine_Section_Manage_Common_ArticleText').toUpperCase()}</p>
				<div className="editorHolder">
					<Field
						name="body"
						component={CKEditor}
						validate={required}
						addButtons={this.addButtons}
						addCommands={this.addCommands}
						userPreferences={userPreferences}
						baseAPI={baseAPI}
						token={userTokenForUpload}
						serif={true}
					/>
				</div>
			</div>
		);

		const editableContentInfoBlock = (
			<SidebarBlock title={t('Shop_ManageShop_Products_CreateProduct_Label_Information').toUpperCase()}>
				<PortalPageSection usage="admin">
					<Field
						name="tags"
						component={PortalSelectMenu}
						items={tags}
						validate={[required]}
						multi={true}
						closeOnSelect={false}
						isRequired={true}
						isDisabled={currentFormValues && !currentFormValues.languageKey}
						label={'#' + t('Magazine_Article_ManageArticle_Dropdown_SelectTags').toLowerCase() + '...'}
						usage="admin"
					/>
					<div className="articleTitle">
						<Field
							name="name"
							component={PortalInputField}
							usage="admin"
							type="text"
							label={t('Magazine_Article_ManageArticle_Label_Title') + '...'}
							validate={[required, maxLength255]}
							onChange={(e) => this.handleTitleChange(e)}
						/>
					</div>

					<div className="abstract">
						<Field
							name="abstract"
							component={PortalTextareaField}
							usage="admin"
							type="textarea"
							rows="5"
							autoFocus={false}
							validate={[maxLength500]}
							maxLength={500}
							label={t('Magazine_Article_ManageArticle_Label_Abstract') + '...'}
						/>
					</div>
					<div className="articleTitleSecond">
						<Field
							className={this.props.manageArticle.error ? 'withError' : ''}
							name="code"
							component={PortalInputField}
							{...{
								errors: this.props.manageArticle.error ? this.props.manageArticle.message.error : undefined,
							}}
							usage="admin"
							type="text"
							label={t('Magazine_Article_ManageArticle_Label_FriendlyUrl')}
							validate={[required, alphabetAndMinusCharacter]}
							description={
								!this.props.manageArticle.error
									? `${this.props.fetchDefault?.baseUrlClient}/magazine/article/${
											this.props.currentFormValues.code ? this.props.currentFormValues.code : ''
									  }`
									: null
							} // FIXME Use correct url
							readOnly={true}
						/>
					</div>
				</PortalPageSection>
			</SidebarBlock>
		);

		const editableContentLanguageBlock = (
			<SidebarBlock>
				<PortalPageSection usage="admin">
					<div className="row">
						<div className="col-md-12">
							<Field
								name="languageKey"
								component={PortalSelectMenu}
								items={this.props.languageDomainValues}
								autoFocus={true}
								isRequired={true}
								validate={[required]}
								label={t('Magazine_Article_ManageArticle_Label_Language')}
								onChange={this.onLanguageChange}
								usage="admin"
								searchable={false}
							/>
						</div>
					</div>
				</PortalPageSection>
			</SidebarBlock>
		);

		const editableContentImageBlock = (
			<div
				className="articleEditorModals"
				ref={(galleryPopUp) => {
					this.galleryPopUp = galleryPopUp;
				}}
			>
				<div className="outerHolder">
					<div className="innerHolder galleryModal">
						<div className="mainTitle blockLabel">
							{t('PortalPage_Section_Manage_Common_CoverPicture').toUpperCase()}
						</div>
						<div className="dropzone">
							<PortalPageSection usage="admin">
								<div className="row">
									<div className="col">
										<p className="grayGigo coverPictureText">
											{'JPEG, PNG, GIF (' +
												t('User_UserCard_Optimal') +
												': 800 x 1200, ' +
												t('Offices_filter_Distance_Max').toLowerCase() +
												' 4MB)'}
										</p>
									</div>
								</div>
								<Field
									name="galleryImageFileUpload"
									dropZoneRef={this.dropzoneRef}
									withRef={true}
									component={ImageUpload}
									imageUploadedCallback={this.mainImageUploadedCallback}
									imageUploadFailed={this.imageUploadFailed}
									maxImageSize={c.MAX_PRODUCT_IMAGE_SIZE}
									plainInput={false}
									additionalData={['picture', 'pictureId']}
									existingImageId={
										this.props.currentFormValues.pictureId ? this.props.currentFormValues.pictureId : null
									}
									existingImageUrl={this.props.currentFormValues.picture ? this.props.currentFormValues.picture : null}
									uploadImageIcon={renderIcon('upload')}
									uploadDescription={t('CropImageModal_Button_UploadPhoto')}
									customUploadAction={this.editCoverImage}
								/>
							</PortalPageSection>
						</div>
						<ButtonsSection>
							<div className="row">
								<div className="col-sm-12 textCenter d-flex">
									{saveAsDraftButton}
									{approveButton}
								</div>
							</div>
						</ButtonsSection>
					</div>
				</div>
			</div>
		);

		const editableContent = (
			<div>
				{editableContentInfoBlock}
				{editableContentTextBlock}
				{editableContentLanguageBlock}
				{editableContentImageBlock}
			</div>
		);

		// show portal or administration layout
		let content = (
			<AuthConsumer>
				{({ isAuthenticated, signinRedirect }) => {
					if (isAuthenticated()) {
						return (
							<RightColumnPortalPage>
								<div className="manageArticleWrapper">
									<form onSubmit={handleSubmit(this.onSubmit)} autoComplete="off">
										<Field name="itemsJArray" type="hidden" component="input" />
										<h1>
											{currentFormValues.status === ArticleStatus.Draft
												? t('Magazine_Article_ManageArticle_Create_Title')
												: t('Magazine_Article_ManageArticle_Edit_Title')}
										</h1>
										{editableContent}
									</form>
								</div>
							</RightColumnPortalPage>
						);
					} else {
						signinRedirect();
					}
				}}
			</AuthConsumer>
		);

		if (this.props.location.pathname.includes('/admin/')) {
			content = (
				<div className="manageArticleWrapper">
					<form onSubmit={handleSubmit(this.onSubmit)}>
						<Field name="itemsJArray" type="hidden" component="input" />
						{editableContent}
					</form>
				</div>
			);
		}

		return content;
	}
}

function mapStateToProps(state: IStore) {
	const articleData: IManageArticle = state.manageArticle;
	if (articleData.article.tags && articleData.article.tags.length > 0 && !Array.isArray(articleData.article.tags)) {
		const splitted = articleData.article.tags.split(' ');
		articleData.article.tags = splitted; //.join(',');
	}

	let currentFormValues: IArticle = null;
	if (state.form[c.FORM_NAME_MANAGE_ARTICLE] && state.form[c.FORM_NAME_MANAGE_ARTICLE].values) {
		currentFormValues = state.form[c.FORM_NAME_MANAGE_ARTICLE].values;
	} else {
		currentFormValues = articleData.article;
	}

	if (articleData.article && currentFormValues && articleData.article.status > currentFormValues.status) {
		currentFormValues.status = articleData.article.status;
	}

	if (articleData.article && currentFormValues && !currentFormValues.id && articleData.article.id) {
		currentFormValues.id = articleData.article.id;
	}

	// autofill user language
	let initialValues = articleData.article;
	if (!initialValues.languageKey && state.userLanguage.languageKey) {
		initialValues = { ...initialValues, languageKey: state.userLanguage.languageKey };
	}

	return {
		userPreferences: state.userPreferences,
		manageArticle: articleData,
		initialValues,
		languageDomainValues: state.domainValues.languages,
		fetchDefault: state.fetchDefault,
		currentFormValues,
		baseAPI: state.fetchDefault.baseAPI,
		formErrors: getFormSyncErrors(c.FORM_NAME_MANAGE_ARTICLE)(state),
	};
}

let ManageArticle = reduxForm(
	{
		form: c.FORM_NAME_MANAGE_ARTICLE,
		enableReinitialize: true,
		keepDirtyOnReinitialize: true,
		onSubmitFail: () => scrollErrorIntoView(),
	},
	mapStateToProps,
)(ManageArticleForm);

ManageArticle = connect(mapStateToProps, (dispatch) => ({
	getArticle: (id: string) => dispatch(getArticle(id)),
	submitCreateArticle: (article: IArticle, isApproval: boolean) => dispatch(submitCreateArticle(article, isApproval)),
	submitUpdateArticle: (article: IArticle, isApproval: boolean) => dispatch(submitUpdateArticle(article, isApproval)),
	setArticleStatus: (id: string, status: ArticleStatus) => dispatch(setArticleStatus(id, status)),
	clearManageArticleFormError: () => dispatch(clearManageArticleFormError()),
	setManageArticleValidationFailure: (error: any) => dispatch(setManageArticleValidationFailure(error)),
	closeModal: () => dispatch(closeModal()),
	showModal: (modalType: string, modalProps: any) => dispatch(showModal(modalType, modalProps)),
	submit: (formName: string) => dispatch(submit(formName)),
	setCoverImagesTab: (tab: string) => dispatch(setCoverImagesTab(tab)),
	clearFormData: () => dispatch(clearFormData()),
	cropAndSaveCoverImage: (image: ICropImageData) => dispatch(cropAndSaveCoverImage(image)),
	cropAndSaveSliderImage: (image: ICropImageData, slideIndex: number, fieldName: string, formName: string) =>
		dispatch(cropAndSaveSliderImage(image, slideIndex, fieldName, formName)),
	changeFormField: (formName: string, field: string, value: string) => dispatch(change(formName, field, value)),
	notifSend: (data: any) => dispatch(notifSend(data)),
	setOriginalArticleItems: (items: IArticleProductItem[]) => dispatch(setOriginalArticleItems(items)),
}))(ManageArticle);

export { ManageArticle };
